import React, {useEffect} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";

import styles from './HistoryOrderDetailsPage.module.scss';
import AddressDetailsOrder from "../../components/AddressDetailsOrder/AddressDetailsOrder";
import PackageDetailsOrder from "../../components/PackageDetailsOrder/PackageDetailsOrder";
import AdditionalInfoOrder from "../../components/AdditionalInfoOrder/AdditionalInfoOrder";
import AddedPhotosCustomerOrder from "../../components/AddedPhotosCustomerOrder/AddedPhotosCustomerOrder";
import coins from "../../constants/images/coins-stacked.svg";
import creditCardCheck from "../../constants/images/detailsOrder/credit-card-check.svg";
import techSupportIcon from '../../constants/images/detailsOrder/tech-support.svg';
import AddedPhotosCompletedWork from "../../components/AddedPhotosCompletedWork/AddedPhotosCompletedWork";
import ReviewFromCustomer from "../../components/ReviewFromCustomer/ReviewFromCustomer";
import {orderActions} from "../../store/slices/orderSlice";
import Loader from "../../components/Loader/Loader";
import IsCleaner from "../../HOC/IsCleaner";
import {MAIN_ROUTES} from "../../routing/main_routes";

const HistoryOrderDetailsPage = () => {
    const {pathname} = useLocation();
    const navigate = useNavigate();
    const array = pathname?.split('/');
    let id; // getting id from url
    if ((typeof +array[array.length - 1] === "number") && (+array[array.length - 1] !== 0)) {
        id = +array[array.length - 1];
    } else {
        id = +array[array.length - 2];
    }

    const dispatch = useDispatch();
    const {order, status} = useSelector(state => state.order);

    useEffect(() => {
        const getOrderById = async () => {
            try {
                await dispatch(orderActions.getById({id}));
            } catch (error) {
                console.error(error);
            }
        }

        getOrderById();
    }, []);

    const {offer, to_client_feedback, to_cleaner_feedback} = order || {};
    const {cleaner_request, application} = offer || {};
    const {
        created_by_user,
        address,
        request_datetime,
        service_package,
        services,
        room_count,
        cleaning_type,
        reg_window_count,
        wc_count,
        pano_window_count,
        photos,
        present_at_home,
        present_at_home_desc,
        comment
    } = cleaner_request || {};

    if (status === 'loading') {
        return <Loader/>;
    }

    return (
        <div className={styles.historyOrderDetailsPage_wrapper}>
            <div className={styles.historyOrderDetailsPage}>
                <h1 className={styles.historyOrderDetailsPage_title}>Замовлення {created_by_user?.first_name}</h1>

                <div className={styles.historyOrderDetailsPage_content}>
                    <div className={styles.historyOrderDetailsPage_content_leftSideContainer}>
                        <div className={styles.historyOrderDetailsPage_content_leftSideContainer_orderDetails}>
                            <AddressDetailsOrder
                                address={address}
                                date={new Date(request_datetime)?.toLocaleDateString()}
                                time={new Date(request_datetime)?.toLocaleTimeString()}
                                price={null}
                            />
                            <PackageDetailsOrder
                                showTitle={true}
                                style={{'padding': '24px 24px 16px 24px', 'borderBottom': '1px solid #D9DBDD'}}
                                selectedPackage={service_package?.name}
                                services={services}
                                countBathrooms={wc_count}
                                countRooms={room_count}
                                countOrdinaryWindows={reg_window_count}
                                countPanoramicWindows={pano_window_count}
                                typeCleaning={cleaning_type}
                            />
                            <AdditionalInfoOrder
                                present_at_home={present_at_home}
                                present_at_home_desc={present_at_home_desc}
                                comment={comment}
                                isBorderBottom={false}

                            />
                            {photos?.length > 0 && <AddedPhotosCustomerOrder photos={photos}/>}
                        </div>

                        <AddedPhotosCompletedWork
                            clientPhotos={to_cleaner_feedback?.photos || []}
                            cleanerPhotos={to_client_feedback?.photos || []}
                        />
                        {!!to_cleaner_feedback && <ReviewFromCustomer order={{cleaning_type}} feedback={to_cleaner_feedback}/>}
                    </div>

                    <div className={styles.historyOrderDetailsPage_content_rightSide}>
                        <div
                            className={styles.historyOrderDetailsPage_content_rightSide_support}
                            onClick={() => navigate(MAIN_ROUTES.SUPPORT, {state: {orderId: id, autoOpen: true}})}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => e.key === 'Enter' && navigate(MAIN_ROUTES.SUPPORT, {state: {orderId: id, autoOpen: true}})}
                        >
                            <img src={techSupportIcon} alt="tech support icon"/>
                            <p>Звʼязатися з підтримкою</p>
                        </div>
                        <div className={styles.historyOrderDetailsPage_content_rightSide_payment}>
                            <p className={styles.historyOrderDetailsPage_content_rightSide_payment_title}>Оплата</p>
                            <div className={styles.historyOrderDetailsPage_content_rightSide_payment_content}>
                                <div
                                    className={styles.historyOrderDetailsPage_content_rightSide_payment_content_blockContainer}>
                                    <div
                                        className={styles.historyOrderDetailsPage_content_rightSide_payment_content_blockContainer_subtitle}>
                                        <img src={coins} alt="coins icon"/>
                                        <p>Ціна прибирання</p>
                                    </div>
                                    <p>₴ {(+application?.application_price).toFixed(2)}</p>
                                </div>

                                <div
                                    className={styles.historyOrderDetailsPage_content_rightSide_payment_content_blockContainer}>
                                    <div
                                        className={styles.historyOrderDetailsPage_content_rightSide_payment_content_blockContainer_subtitle}>
                                        <img src={coins} alt="coins icon"/>
                                        <p>Комісія 20%</p>
                                    </div>
                                    <p>₴ {(+application?.application_price * 0.2).toFixed(2)}</p>
                                </div>

                                <div
                                    className={styles.historyOrderDetailsPage_content_rightSide_payment_content_blockContainer}>
                                    <div
                                        className={styles.historyOrderDetailsPage_content_rightSide_payment_content_blockContainer_subtitle}>
                                        <img src={creditCardCheck} alt="credit card check icon"/>
                                        <p>Чистий дохід</p>
                                    </div>
                                    <p>₴ {(+application?.application_price * 0.8).toFixed(2)}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IsCleaner(HistoryOrderDetailsPage);
